import React from 'react';
import type { RouteObject } from 'react-router-dom';
import ChecklistsList from './ChecklistsList';
import ChecklistDetail from './ChecklistDetail';

export const checklistsRoutes: RouteObject[] = [
  { path: 'checklists', element: <ChecklistsList /> },
  { path: 'checklists/:slug', element: <ChecklistDetail /> },
];
